import React from 'react'
import { clsx } from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  title?: string
  subtitle?: string
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  title,
  subtitle
}) => {
  return (
    <div className={clsx('bg-white rounded-lg shadow-lg p-6', className)}>
      {title && (
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          {subtitle && (
            <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </div>
  )
}
